export default __webpack_public_path__ + "dashboard.14947af.png";